import Download from 'assets/icons/fa/download.svg'

Download.displayName = 'Download'
export default Download
